import { logUsage } from 'owa-analytics';
import type { KeydownConfig } from 'owa-hotkeys';
import { getSelectedTableView } from 'owa-mail-list-store';
import { lazyManualSyncMail } from 'owa-mail-manual-sync';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import { getCommands } from '../utils/MailModuleHotKeys';

export function setupSyncMailboxHotKeys(): KeydownConfig[] {
    return [{ command: getCommands().syncMailbox, handler: syncMailbox }];
}

function syncMailbox() {
    logUsage('SyncButtonClicked', getModuleContextMailboxInfo(), {
        source: 'Ribbon',
    });
    lazyManualSyncMail.importAndExecute(getSelectedTableView());
}
